export default __webpack_public_path__ + "static/media/smoke-and-mirrors.57143109.jpg";